let persistentResult = true

const CheckGroupIsValid = (pFormElm, pGroupName) => {
  persistentResult = true
  runThroughElms(pFormElm, pGroupName)
  return persistentResult
}

const runThroughElms = (pElement, pGroup) => {
  const isValidationFunction = typeof pElement.runValidation === 'function'
  const isGrouped = pElement.validation && pElement.validation.group
  if (isValidationFunction && isGrouped) {
    if (pGroup.includes(pElement.validation.group)) resultRunValidation(pElement)
  } else if (isValidationFunction && !isGrouped) {
    resultRunValidation(pElement)
  }

  if (pElement.$children) {
    for (let element in pElement.$children) {
      runThroughElms(pElement.$children[element], pGroup)
    }
  }
}

const resultRunValidation = (pElement) => {
  const resultOfValidation = pElement.runValidation()
  if (!resultOfValidation) {
    persistentResult = false
    return false
  }
}

export {
  CheckGroupIsValid
}



// WEBPACK FOOTER //
// ./src/components/primitives/validator/validator-helper/ValidatorHelper.js